import { useEffect } from 'react';

import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

export function useAddSupporterVoiceThankYou() {
	const { track } = useCampaignTracking();

	useEffect(() => {
		track('campaign_action_add_supporter_voice_thank_you_view');
	}, [track]);
}
